import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { TABLE_SETTINGS, MESSAGES, THEME } from "../utills/constant";
import { IoClose } from "react-icons/io5";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { MdEdit } from "react-icons/md";
import { GoDatabase } from "react-icons/go";
import { GrDocumentConfig } from "react-icons/gr";
import { IoPersonAddOutline } from "react-icons/io5";
import { LiaTrashRestoreAltSolid } from "react-icons/lia";
import { IoTrashBinOutline } from "react-icons/io5";
import {
  getAllServerType,
  GetSingleServerType,
  updateServiceType,
  blockServerType,
} from "../store/actions/servertype";
const ServerTypeTable = ({ userHeader, userProducts, loading }) => {
  // redux logic
  const users = useSelector((state) => state.userManagement);
  const dispatch = useDispatch();
  const [editModal, setEditModal] = useState(false);
  const [Id, setId] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [configModal, setConfigModal] = useState(false);
  const [configData, setConfigData] = useState({
    port: "8080",
    ram: "8GB",
    storage: "256GB",
    core: "4",
    pricing: "100$",
    bandwidth: "300gb",
  });
  const [assignModal, setAssignModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState("");
  const dummyUsers = ["John Doe", "Jane Smith", "Alice Johnson", "Bob Brown"];

  const handleAssignUser = () => {
    console.log("Assigned user:", selectedUser);
    toast.success(`Assigned to ${selectedUser}`, {
      position: "top-right",
      autoClose: 1000,
    });
    setAssignModal(false);
    setSelectedUser("");
  };

  const itemsPerPage = TABLE_SETTINGS.DEFAULT_PAGE_SIZE;
  const totalItems = userProducts.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  useEffect(() => {
    if (Id) {
      dispatch(GetSingleServerType(Id));
    }
  }, [dispatch, Id]);

  const allServers = useSelector((state) => state.serverType.servers);
  const singleServer = allServers.find((item) => item._id === Id);

  // console.log("singler server ", singleServer);
  useEffect(() => {
    if (singleServer) {
      setFormData({
        name: singleServer.name || "",
        status: singleServer.status || "1",
        id: singleServer._id || null,
      });
    }
  }, [singleServer]);

  const toggleModal = () => {
    setEditModal(false);
  };
  const [formData, setFormData] = useState({
    name: "",
    status: "1",
    id: null,
  });
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const getServerType = () => {
    dispatch(getAllServerType({}));
  };
  const handleSaveServerType = (e) => {
    e.preventDefault();

    const updatedData = {
      ...formData,
      id: Id, // Add the id here
    };

    console.log("Form data being sent:", updatedData);
    // dispatch(updateServiceType({ id: formData.id, data: { name: formData.name, status: formData.status } })).then(() => {
    //   toast.success("Server type updated successfully!", {
    //     position: "top-right",
    //     autoClose: 600,
    //     onClose: () => {
    //       getServerType(); // Refresh list
    //     },
    //   });
    // });

    dispatch(
      updateServiceType({
        id: formData.id,
        data: { name: formData.name, status: formData.status },
      })
    );
    toast.success("Server type updated successfully!", {
      position: "top-right",
      autoClose: 600,
      onClose: () => {
        getServerType(); // Refresh list
      },
    });

    // dispatch(updateServiceType(updatedData)).then(() => {
    //   toast.success("Server type updated successfully!", {
    //     position: "top-right",
    //     autoClose: 600,
    //     onClose: () => {
    //       getServerType(); // Refresh list
    //     },
    //   });
    // });

    // Clear form and close modal
    setFormData({
      name: "",
      status: "1",
      id: -1,
    });
    setEditModal(false);
  };

  const BlockServerServerType = (id) => {
    const updatedData = {
      id: id,
    };

    console.log("Form data being sent:", id);

    dispatch(blockServerType({ id: id })).then(() => {
      toast.success("Server type block successfully!", {
        position: "top-right",
        autoClose: 600,
        onClose: () => {
          getServerType(); // Refresh list
        },
      });
    });
  };

  const handleUnblockServerType = (id) => {
    dispatch(updateServiceType({ id: id, data: { status: 1 } }));
    toast.success("Unblock server successfully!", {
      position: "top-right", // Use string instead of POSITION.TOP_RIGHT
      autoClose: 600,
      onClose: () => {
        // handleFetchData();
      },
    });
  };

  // Calculate current items based on pagination
  const currentItems = userProducts.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const generatePageNumbers = () => {
    const pages = new Set();

    // Always include the first page
    pages.add(1);

    // Include "..." before middle pages if needed
    if (currentPage > 3) pages.add("...");

    // Include pages around the current page
    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);
    for (let i = start; i <= end; i++) {
      pages.add(i);
    }

    // Include "..." after middle pages if needed
    if (currentPage < totalPages - 2) pages.add("...");

    // Always include the last page
    if (totalPages > 1) {
      pages.add(totalPages);
    }

    return Array.from(pages);
  };

  const paginationNumbers = generatePageNumbers();

  return (
    <div className="relative bg-card overflow-x-auto shadow-md sm:rounded-lg m-2">
      {loading ? (
        <div className="text-center text-gray-500">{MESSAGES.LOADING}</div>
      ) : totalItems === 0 ? (
        <div className="text-center text-gray-500">{MESSAGES.NO_DATA}</div>
      ) : (
        <>
          <div className="overflow-x-auto">
            <table className="w-full table-fixed text-sm text-left text-gray-500 bg-card">
              <thead className="text-xs uppercase bg-[#02256d] text-white">
                <tr>
                  <th className="w-[5%] p-4 items-center justify-center">
                    <input type="checkbox" />
                  </th>
                  <th className="w-[30%] px-6 py-3">Name</th>
                  <th className="w-[20%] px-6 py-3">Action</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map((product, index) => (
                  <tr key={index} className="border-b hover:bg-gray-50">
                    <td className="w-[5%] p-4">
                      <input type="checkbox" />
                    </td>
                    <td className="w-[30%] px-6 py-4 font-medium">
                      {product.name}
                    </td>
                    <td className="w-[35%] px-6 py-4">
                      <div className="flex flex-wrap justify-between">
                        <button
                          title="Edit"
                          className="font-medium text-blue-600  border  border-blue-600  px-2 rounded-lg hover:text-white hover:bg-blue-600"
                        >
                          <MdEdit className="text-lg" />
                        </button>
                        <button
                          title="data"
                          className="text-green-600 border border-green-600 px-2 py-1 rounded-lg hover:text-white hover:bg-green-600 flex items-center justify-center"
                        >
                          <GoDatabase className="text-lg" />
                        </button>
                        <button
                          className="text-yellow-600 border border-yellow-600 px-2 rounded-lg hover:bg-yellow-600 hover:text-white"
                          title="configration"
                          onClick={() => {
                            setConfigModal(true);
                            setConfigData({
                              port: "8080",
                              ram: "8GB",
                              storage: "256GB",
                              core: "4",
                              pricing: "100$",
                              bandwidth: "300gb",
                            }); // later replace with dynamic values
                          }}
                        >
                          <GrDocumentConfig className="text-lg" />
                        </button>

                        <button
                          className="text-purple-600 border border-purple-600 px-2 rounded-lg hover:bg-purple-600 hover:text-white"
                          title="assign"
                          onClick={() => setAssignModal(true)}
                        >
                          <IoPersonAddOutline className="text-lg" />
                        </button>

                        {product?.status === "1" ? (
                          <button
                            onClick={() => BlockServerServerType(product._id)}
                            title="Block"
                            className="text-red-600 border border-red-600 px-2 rounded-lg hover:bg-red-600 hover:text-white"
                          >
                            <IoTrashBinOutline className="text-lg" />
                          </button>
                        ) : (
                          <button
                            onClick={() => handleUnblockServerType(product._id)}
                            title="Unblock"
                            className="text-green-600 border border-green-600 px-2 rounded-lg hover:bg-green-600 hover:text-white"
                          >
                            <LiaTrashRestoreAltSolid className="text-lg" />
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {editModal && (
              <div className="fixed inset-0 mt-4 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50">
                <div className="relative p-4 w-full max-w-md h-auto overflow-hidden">
                  <div className="relative bg-card rounded-lg shadow max-h-[90vh] overflow-y-auto">
                    {/* Modal Header */}
                    <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
                      <h3 className="text-lg font-semibold text-text">
                        Add New Server Type
                      </h3>
                      <button
                        type="button"
                        className="text-text bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600"
                        onClick={toggleModal}
                      >
                        <IoClose className="w-5 h-5" />
                      </button>
                    </div>

                    {/* Modal Body */}
                    <form
                      className="p-4 md:p-5"
                      onSubmit={handleSaveServerType}
                    >
                      <div className="grid gap-4 mb-4 grid-cols-1">
                        <div>
                          <label
                            htmlFor="name"
                            className="block mb-2 text-sm font-medium text-text"
                          >
                            Server type name
                          </label>
                          <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={(e) =>
                              setFormData((prev) => ({
                                ...prev,
                                name: e.target.value,
                              }))
                            }
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                            placeholder="Enter your name"
                            required
                          />
                        </div>
                      </div>

                      <button
                        type="submit"
                        className="w-full justify-center text-white inline-flex items-center bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            )}

            {configModal && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                <div className="bg-white dark:bg-gray-800 p-6 rounded-lg w-full max-w-md shadow-md">
                  <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-semibold text-gray-800 dark:text-white">
                      Server Configuration
                    </h2>
                    <button
                      onClick={() => setConfigModal(false)}
                      className="text-gray-500 hover:text-red-600"
                    >
                      <IoClose className="text-2xl" />
                    </button>
                  </div>

                  <div className="space-y-3 text-gray-700 dark:text-gray-300">
                    <div>
                      <strong>Port:</strong> {configData.port}
                    </div>
                    <div>
                      <strong>RAM:</strong> {configData.ram}
                    </div>
                    <div>
                      <strong>Storage:</strong> {configData.storage}
                    </div>
                    <div>
                      <strong>Core:</strong> {configData.core}
                    </div>
                    <div>
                      <strong>Pricing:</strong> {configData.pricing}
                    </div>
                    <div>
                      <strong>BandWidth:</strong> {configData.bandwidth}
                    </div>
                  </div>

                  <div className="mt-6 text-right">
                    {/* <button
                      onClick={() => setConfigModal(false)}
                      className="bg-[#02256d] text-white px-4 py-2 rounded hover:bg-[#011d58]"
                    >
                      Close
                    </button> */}
                  </div>
                </div>
              </div>
            )}

            {assignModal && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                <div className="bg-white dark:bg-gray-800 p-6 rounded-lg w-full max-w-md shadow-md">
                  <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-semibold text-gray-800 dark:text-white">
                      Assign a User
                    </h2>
                    <button
                      onClick={() => setAssignModal(false)}
                      className="text-gray-500 hover:text-red-600"
                    >
                      <IoClose className="text-2xl" />
                    </button>
                  </div>

                  <div className="mb-4">
                    <label
                      htmlFor="user-select"
                      className="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300"
                    >
                      Select a User
                    </label>
                    <select
                      id="user-select"
                      value={selectedUser}
                      onChange={(e) => setSelectedUser(e.target.value)}
                      className="w-full p-2 border rounded-md dark:bg-gray-700 dark:text-white"
                    >
                      <option value="">-- Select a user --</option>
                      {dummyUsers.map((user, index) => (
                        <option key={index} value={user}>
                          {user}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="text-right">
                    <button
                      onClick={handleAssignUser}
                      disabled={!selectedUser}
                      className={`px-4 py-2 rounded text-white ${
                        selectedUser
                          ? "bg-[#02256d] hover:bg-[#011d58]"
                          : "bg-gray-400 cursor-not-allowed"
                      }`}
                    >
                      Assign
                    </button>
                  </div>
                </div>
              </div>
            )}

            <nav
              className="flex items-center justify-between m-4"
              aria-label="Table navigation"
            >
              <span className="text-sm font-normal text-black">
                Showing{" "}
                <span className="font-semibold text-text">
                  {(currentPage - 1) * itemsPerPage + 1} -{" "}
                  {Math.min(currentPage * itemsPerPage, totalItems)}
                </span>{" "}
                of <span className="font-semibold text-text">{totalItems}</span>
              </span>
              <ul className="inline-flex -space-x-px text-sm h-8">
                {/* Previous Button */}
                <li>
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="flex items-center justify-center px-3 h-8 text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100"
                  >
                    Previous
                  </button>
                </li>

                {/* Page Numbers */}
                {paginationNumbers.map((page, index) => (
                  <li key={index}>
                    {page === "..." ? (
                      <span className="flex items-center justify-center px-3 h-8 text-gray-500 bg-white border border-gray-300">
                        ...
                      </span>
                    ) : (
                      <button
                        onClick={() => handlePageChange(page)}
                        className={`flex items-center justify-center px-3 h-8 ${
                          currentPage === page
                            ? "text-white bg-[#02256d]"
                            : "text-gray-500 bg-white"
                        } border border-gray-300 hover:bg-[#02256d]`}
                      >
                        {page}
                      </button>
                    )}
                  </li>
                ))}

                {/* Next Button */}
                <li>
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="flex items-center justify-center px-3 h-8 text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-100"
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </>
      )}
    </div>
  );
};

export default ServerTypeTable;
